var map = {
	"./abdm-integration/ar.resource.json": [
		76137,
		[
			76137
		]
	],
	"./abdm-integration/bn.resource.json": [
		42584,
		[
			42584
		]
	],
	"./abdm-integration/en.resource.json": [
		87353,
		[
			87353
		]
	],
	"./abdm-integration/es.resource.json": [
		90672,
		[
			90672
		]
	],
	"./abdm-integration/fr.resource.json": [
		3672,
		[
			3672
		]
	],
	"./abdm-integration/gu.resource.json": [
		31311,
		[
			53692
		]
	],
	"./abdm-integration/hi.resource.json": [
		34965,
		[
			34965
		]
	],
	"./abdm-integration/km.resource.json": [
		62880,
		[
			62880
		]
	],
	"./abdm-integration/kn.resource.json": [
		18623,
		[
			18623
		]
	],
	"./abdm-integration/ml.resource.json": [
		13539,
		[
			13539
		]
	],
	"./abdm-integration/mr.resource.json": [
		52933,
		[
			52933
		]
	],
	"./abdm-integration/nl.resource.json": [
		17838,
		[
			17838
		]
	],
	"./abdm-integration/pa.resource.json": [
		94997,
		[
			94997
		]
	],
	"./abdm-integration/ta.resource.json": [
		57641,
		[
			57641
		]
	],
	"./abdm-integration/te.resource.json": [
		63397,
		[
			63397
		]
	],
	"./abdm-integration/vi.resource.json": [
		77519,
		[
			77519
		]
	],
	"./abdm-integration/zh-CN.resource.json": [
		87404,
		[
			87404
		]
	],
	"./account-management/ar.resource.json": [
		11167,
		[
			11167
		]
	],
	"./account-management/bn.resource.json": [
		36570,
		[
			36570
		]
	],
	"./account-management/en.resource.json": [
		27151,
		[
			27151
		]
	],
	"./account-management/es.resource.json": [
		16414,
		[
			16414
		]
	],
	"./account-management/fr.resource.json": [
		58642,
		[
			58642
		]
	],
	"./account-management/gu.resource.json": [
		75010,
		[
			75010
		]
	],
	"./account-management/hi.resource.json": [
		26607,
		[
			26607
		]
	],
	"./account-management/km.resource.json": [
		11790,
		[
			11790
		]
	],
	"./account-management/kn.resource.json": [
		44393,
		[
			44393
		]
	],
	"./account-management/ml.resource.json": [
		72709,
		[
			72709
		]
	],
	"./account-management/mr.resource.json": [
		24419,
		[
			24419
		]
	],
	"./account-management/nl.resource.json": [
		3796,
		[
			3796
		]
	],
	"./account-management/pa.resource.json": [
		92399,
		[
			92399
		]
	],
	"./account-management/ta.resource.json": [
		72699,
		[
			72699
		]
	],
	"./account-management/te.resource.json": [
		37943,
		[
			37943
		]
	],
	"./account-management/vi.resource.json": [
		95445,
		[
			95445
		]
	],
	"./account-management/zh-CN.resource.json": [
		14806,
		[
			14806
		]
	],
	"./adt/ar.resource.json": [
		44289,
		[
			44289
		]
	],
	"./adt/bn.resource.json": [
		51488,
		[
			51488
		]
	],
	"./adt/en.resource.json": [
		11265,
		[
			11265
		]
	],
	"./adt/es.resource.json": [
		98024,
		[
			98024
		]
	],
	"./adt/fr.resource.json": [
		1200,
		[
			1200
		]
	],
	"./adt/gu.resource.json": [
		83892,
		[
			83892
		]
	],
	"./adt/hi.resource.json": [
		56813,
		[
			56813
		]
	],
	"./adt/km.resource.json": [
		38712,
		[
			38712
		]
	],
	"./adt/kn.resource.json": [
		25879,
		[
			25879
		]
	],
	"./adt/ml.resource.json": [
		20923,
		[
			20923
		]
	],
	"./adt/mr.resource.json": [
		39245,
		[
			39245
		]
	],
	"./adt/nl.resource.json": [
		93510,
		[
			93510
		]
	],
	"./adt/pa.resource.json": [
		44506,
		[
			22125
		]
	],
	"./adt/ta.resource.json": [
		33646,
		[
			33646
		]
	],
	"./adt/te.resource.json": [
		96125,
		[
			96125
		]
	],
	"./adt/vi.resource.json": [
		41687,
		[
			41687
		]
	],
	"./adt/zh-CN.resource.json": [
		5364,
		[
			5364
		]
	],
	"./aiml-gateway/ar.resource.json": [
		60486,
		[
			60486
		]
	],
	"./aiml-gateway/bn.resource.json": [
		96795,
		[
			96795
		]
	],
	"./aiml-gateway/en.resource.json": [
		9902,
		[
			9902
		]
	],
	"./aiml-gateway/es.resource.json": [
		17215,
		[
			17215
		]
	],
	"./aiml-gateway/fr.resource.json": [
		1227,
		[
			1227
		]
	],
	"./aiml-gateway/gu.resource.json": [
		93687,
		[
			93687
		]
	],
	"./aiml-gateway/hi.resource.json": [
		34250,
		[
			34250
		]
	],
	"./aiml-gateway/km.resource.json": [
		36179,
		[
			36179
		]
	],
	"./aiml-gateway/kn.resource.json": [
		20132,
		[
			20132
		]
	],
	"./aiml-gateway/ml.resource.json": [
		52116,
		[
			52116
		]
	],
	"./aiml-gateway/mr.resource.json": [
		12106,
		[
			12106
		]
	],
	"./aiml-gateway/nl.resource.json": [
		37381,
		[
			37381
		]
	],
	"./aiml-gateway/pa.resource.json": [
		33722,
		[
			33722
		]
	],
	"./aiml-gateway/ta.resource.json": [
		94502,
		[
			94502
		]
	],
	"./aiml-gateway/te.resource.json": [
		8866,
		[
			8866
		]
	],
	"./aiml-gateway/vi.resource.json": [
		58004,
		[
			58004
		]
	],
	"./aiml-gateway/zh-CN.resource.json": [
		64957,
		[
			64957
		]
	],
	"./alertmanager/ar.resource.json": [
		39464,
		[
			17083
		]
	],
	"./alertmanager/bn.resource.json": [
		19294,
		[
			19294
		]
	],
	"./alertmanager/en.resource.json": [
		53067,
		[
			53067
		]
	],
	"./alertmanager/es.resource.json": [
		3586,
		[
			3586
		]
	],
	"./alertmanager/fr.resource.json": [
		10742,
		[
			10742
		]
	],
	"./alertmanager/gu.resource.json": [
		7950,
		[
			7950
		]
	],
	"./alertmanager/hi.resource.json": [
		22971,
		[
			22971
		]
	],
	"./alertmanager/km.resource.json": [
		78866,
		[
			78866
		]
	],
	"./alertmanager/kn.resource.json": [
		60429,
		[
			60429
		]
	],
	"./alertmanager/ml.resource.json": [
		62817,
		[
			62817
		]
	],
	"./alertmanager/mr.resource.json": [
		4551,
		[
			4551
		]
	],
	"./alertmanager/nl.resource.json": [
		91360,
		[
			91360
		]
	],
	"./alertmanager/pa.resource.json": [
		71147,
		[
			71147
		]
	],
	"./alertmanager/ta.resource.json": [
		29407,
		[
			29407
		]
	],
	"./alertmanager/te.resource.json": [
		94352,
		[
			71971
		]
	],
	"./alertmanager/vi.resource.json": [
		82841,
		[
			82841
		]
	],
	"./alertmanager/zh-CN.resource.json": [
		76874,
		[
			76874
		]
	],
	"./ambulance-management/ar.resource.json": [
		68000,
		[
			68000
		]
	],
	"./ambulance-management/bn.resource.json": [
		63537,
		[
			63537
		]
	],
	"./ambulance-management/en.resource.json": [
		40176,
		[
			40176
		]
	],
	"./ambulance-management/es.resource.json": [
		36857,
		[
			36857
		]
	],
	"./ambulance-management/fr.resource.json": [
		45233,
		[
			45233
		]
	],
	"./ambulance-management/gu.resource.json": [
		70497,
		[
			70497
		]
	],
	"./ambulance-management/hi.resource.json": [
		27024,
		[
			27024
		]
	],
	"./ambulance-management/km.resource.json": [
		72026,
		[
			49645
		]
	],
	"./ambulance-management/kn.resource.json": [
		84434,
		[
			84434
		]
	],
	"./ambulance-management/ml.resource.json": [
		93098,
		[
			93098
		]
	],
	"./ambulance-management/mr.resource.json": [
		11572,
		[
			11572
		]
	],
	"./ambulance-management/nl.resource.json": [
		82719,
		[
			82719
		]
	],
	"./ambulance-management/pa.resource.json": [
		48688,
		[
			48688
		]
	],
	"./ambulance-management/ta.resource.json": [
		35884,
		[
			35884
		]
	],
	"./ambulance-management/te.resource.json": [
		17944,
		[
			17944
		]
	],
	"./ambulance-management/vi.resource.json": [
		85278,
		[
			85278
		]
	],
	"./ambulance-management/zh-CN.resource.json": [
		73435,
		[
			73435
		]
	],
	"./appointment/ar.resource.json": [
		96139,
		[
			96139
		]
	],
	"./appointment/bn.resource.json": [
		90862,
		[
			90862
		]
	],
	"./appointment/en.resource.json": [
		36539,
		[
			36539
		]
	],
	"./appointment/es.resource.json": [
		76850,
		[
			76850
		]
	],
	"./appointment/fr.resource.json": [
		61510,
		[
			61510
		]
	],
	"./appointment/gu.resource.json": [
		11710,
		[
			11710
		]
	],
	"./appointment/hi.resource.json": [
		96011,
		[
			96011
		]
	],
	"./appointment/km.resource.json": [
		57826,
		[
			57826
		]
	],
	"./appointment/kn.resource.json": [
		51005,
		[
			51005
		]
	],
	"./appointment/ml.resource.json": [
		61201,
		[
			61201
		]
	],
	"./appointment/mr.resource.json": [
		58327,
		[
			58327
		]
	],
	"./appointment/nl.resource.json": [
		73392,
		[
			73392
		]
	],
	"./appointment/pa.resource.json": [
		63259,
		[
			63259
		]
	],
	"./appointment/ta.resource.json": [
		21935,
		[
			21935
		]
	],
	"./appointment/te.resource.json": [
		53651,
		[
			53651
		]
	],
	"./appointment/vi.resource.json": [
		76009,
		[
			76009
		]
	],
	"./appointment/zh-CN.resource.json": [
		48653,
		[
			71034
		]
	],
	"./ar.resource.json": [
		63593,
		[
			63593
		]
	],
	"./billing/ar.resource.json": [
		39165,
		[
			39165
		]
	],
	"./billing/bn.resource.json": [
		10644,
		[
			10644
		]
	],
	"./billing/en.resource.json": [
		6586,
		[
			84205
		]
	],
	"./billing/es.resource.json": [
		22476,
		[
			22476
		]
	],
	"./billing/fr.resource.json": [
		91988,
		[
			91988
		]
	],
	"./billing/gu.resource.json": [
		67440,
		[
			67440
		]
	],
	"./billing/hi.resource.json": [
		12105,
		[
			12105
		]
	],
	"./billing/km.resource.json": [
		35836,
		[
			35836
		]
	],
	"./billing/kn.resource.json": [
		651,
		[
			651
		]
	],
	"./billing/ml.resource.json": [
		38903,
		[
			38903
		]
	],
	"./billing/mr.resource.json": [
		25425,
		[
			25425
		]
	],
	"./billing/nl.resource.json": [
		69122,
		[
			69122
		]
	],
	"./billing/pa.resource.json": [
		91881,
		[
			91881
		]
	],
	"./billing/ta.resource.json": [
		29237,
		[
			29237
		]
	],
	"./billing/te.resource.json": [
		39673,
		[
			39673
		]
	],
	"./billing/vi.resource.json": [
		32107,
		[
			32107
		]
	],
	"./billing/zh-CN.resource.json": [
		25064,
		[
			25064
		]
	],
	"./bireports/ar.resource.json": [
		86374,
		[
			86374
		]
	],
	"./bireports/en.resource.json": [
		15726,
		[
			15726
		]
	],
	"./bireports/es.resource.json": [
		99999,
		[
			99999
		]
	],
	"./bireports/gu.resource.json": [
		58519,
		[
			58519
		]
	],
	"./blood-bank/ar.resource.json": [
		8763,
		[
			8763
		]
	],
	"./blood-bank/bn.resource.json": [
		8702,
		[
			8702
		]
	],
	"./blood-bank/en.resource.json": [
		89304,
		[
			66923
		]
	],
	"./blood-bank/es.resource.json": [
		11842,
		[
			11842
		]
	],
	"./blood-bank/fr.resource.json": [
		59894,
		[
			59894
		]
	],
	"./blood-bank/gu.resource.json": [
		31822,
		[
			31822
		]
	],
	"./blood-bank/hi.resource.json": [
		31003,
		[
			31003
		]
	],
	"./blood-bank/km.resource.json": [
		3026,
		[
			3026
		]
	],
	"./blood-bank/kn.resource.json": [
		50541,
		[
			50541
		]
	],
	"./blood-bank/ml.resource.json": [
		84225,
		[
			84225
		]
	],
	"./blood-bank/mr.resource.json": [
		70279,
		[
			70279
		]
	],
	"./blood-bank/nl.resource.json": [
		54560,
		[
			54560
		]
	],
	"./blood-bank/pa.resource.json": [
		68651,
		[
			68651
		]
	],
	"./blood-bank/ta.resource.json": [
		14751,
		[
			14751
		]
	],
	"./blood-bank/te.resource.json": [
		53027,
		[
			53027
		]
	],
	"./blood-bank/vi.resource.json": [
		50809,
		[
			50809
		]
	],
	"./blood-bank/zh-CN.resource.json": [
		29066,
		[
			29066
		]
	],
	"./bn-console.resource.json": [
		87864,
		[
			87864
		]
	],
	"./bn.resource.json": [
		49816,
		[
			49816
		]
	],
	"./bpmn/ar.resource.json": [
		95879,
		[
			95879
		]
	],
	"./bpmn/bn.resource.json": [
		10610,
		[
			10610
		]
	],
	"./bpmn/en.resource.json": [
		59719,
		[
			59719
		]
	],
	"./bpmn/es.resource.json": [
		29574,
		[
			29574
		]
	],
	"./bpmn/fr.resource.json": [
		47386,
		[
			47386
		]
	],
	"./bpmn/gu.resource.json": [
		66666,
		[
			66666
		]
	],
	"./bpmn/hi.resource.json": [
		17079,
		[
			17079
		]
	],
	"./bpmn/km.resource.json": [
		19414,
		[
			19414
		]
	],
	"./bpmn/kn.resource.json": [
		12913,
		[
			12913
		]
	],
	"./bpmn/ml.resource.json": [
		36333,
		[
			36333
		]
	],
	"./bpmn/mr.resource.json": [
		34363,
		[
			34363
		]
	],
	"./bpmn/nl.resource.json": [
		15804,
		[
			15804
		]
	],
	"./bpmn/pa.resource.json": [
		51927,
		[
			51927
		]
	],
	"./bpmn/ta.resource.json": [
		79235,
		[
			79235
		]
	],
	"./bpmn/te.resource.json": [
		36671,
		[
			36671
		]
	],
	"./bpmn/vi.resource.json": [
		30445,
		[
			30445
		]
	],
	"./bpmn/zh-CN.resource.json": [
		62945,
		[
			85326
		]
	],
	"./care-plan/en.resource.json": [
		1969,
		[
			1969
		]
	],
	"./care-plan/gu.resource.json": [
		50148,
		[
			50148
		]
	],
	"./crm/ar.resource.json": [
		24894,
		[
			24894
		]
	],
	"./crm/bn.resource.json": [
		46691,
		[
			46691
		]
	],
	"./crm/en.resource.json": [
		75702,
		[
			75702
		]
	],
	"./crm/es.resource.json": [
		89175,
		[
			89175
		]
	],
	"./crm/fr.resource.json": [
		30179,
		[
			30179
		]
	],
	"./crm/gu.resource.json": [
		49327,
		[
			49327
		]
	],
	"./crm/hi.resource.json": [
		62146,
		[
			62146
		]
	],
	"./crm/km.resource.json": [
		93675,
		[
			93675
		]
	],
	"./crm/kn.resource.json": [
		28860,
		[
			28860
		]
	],
	"./crm/ml.resource.json": [
		45900,
		[
			45900
		]
	],
	"./crm/mr.resource.json": [
		80754,
		[
			80754
		]
	],
	"./crm/nl.resource.json": [
		2365,
		[
			2365
		]
	],
	"./crm/pa.resource.json": [
		26578,
		[
			26578
		]
	],
	"./crm/ta.resource.json": [
		2366,
		[
			2366
		]
	],
	"./crm/te.resource.json": [
		79706,
		[
			79706
		]
	],
	"./crm/vi.resource.json": [
		31644,
		[
			31644
		]
	],
	"./crm/zh-CN.resource.json": [
		87237,
		[
			87237
		]
	],
	"./cssd/ar.resource.json": [
		18899,
		[
			18899
		]
	],
	"./cssd/bn.resource.json": [
		86278,
		[
			86278
		]
	],
	"./cssd/en.resource.json": [
		63635,
		[
			63635
		]
	],
	"./cssd/es.resource.json": [
		43674,
		[
			43674
		]
	],
	"./cssd/fr.resource.json": [
		66798,
		[
			66798
		]
	],
	"./cssd/gu.resource.json": [
		49926,
		[
			49926
		]
	],
	"./cssd/hi.resource.json": [
		94643,
		[
			94643
		]
	],
	"./cssd/km.resource.json": [
		42762,
		[
			42762
		]
	],
	"./cssd/kn.resource.json": [
		52229,
		[
			52229
		]
	],
	"./cssd/ml.resource.json": [
		57049,
		[
			57049
		]
	],
	"./cssd/mr.resource.json": [
		41660,
		[
			19279
		]
	],
	"./cssd/nl.resource.json": [
		97048,
		[
			97048
		]
	],
	"./cssd/pa.resource.json": [
		27555,
		[
			27555
		]
	],
	"./cssd/ta.resource.json": [
		82903,
		[
			82903
		]
	],
	"./cssd/te.resource.json": [
		17659,
		[
			17659
		]
	],
	"./cssd/vi.resource.json": [
		15617,
		[
			15617
		]
	],
	"./cssd/zh-CN.resource.json": [
		77189,
		[
			99570
		]
	],
	"./data-onboarding/ar.resource.json": [
		76488,
		[
			76488
		]
	],
	"./data-onboarding/bn.resource.json": [
		18313,
		[
			18313
		]
	],
	"./data-onboarding/en.resource.json": [
		40328,
		[
			40328
		]
	],
	"./data-onboarding/es.resource.json": [
		53569,
		[
			53569
		]
	],
	"./data-onboarding/fr.resource.json": [
		11385,
		[
			11385
		]
	],
	"./data-onboarding/gu.resource.json": [
		17193,
		[
			17193
		]
	],
	"./data-onboarding/hi.resource.json": [
		77048,
		[
			77048
		]
	],
	"./data-onboarding/km.resource.json": [
		73749,
		[
			73749
		]
	],
	"./data-onboarding/kn.resource.json": [
		82554,
		[
			82554
		]
	],
	"./data-onboarding/ml.resource.json": [
		93650,
		[
			93650
		]
	],
	"./data-onboarding/mr.resource.json": [
		75148,
		[
			75148
		]
	],
	"./data-onboarding/nl.resource.json": [
		96167,
		[
			96167
		]
	],
	"./data-onboarding/pa.resource.json": [
		31544,
		[
			31544
		]
	],
	"./data-onboarding/ta.resource.json": [
		18420,
		[
			18420
		]
	],
	"./data-onboarding/te.resource.json": [
		29440,
		[
			29440
		]
	],
	"./data-onboarding/vi.resource.json": [
		42486,
		[
			42486
		]
	],
	"./data-onboarding/zh-CN.resource.json": [
		40723,
		[
			40723
		]
	],
	"./diagnostic/ar.resource.json": [
		38221,
		[
			38221
		]
	],
	"./diagnostic/bn.resource.json": [
		65124,
		[
			65124
		]
	],
	"./diagnostic/en.resource.json": [
		28925,
		[
			28925
		]
	],
	"./diagnostic/es.resource.json": [
		46588,
		[
			46588
		]
	],
	"./diagnostic/fr.resource.json": [
		86212,
		[
			86212
		]
	],
	"./diagnostic/gu.resource.json": [
		71744,
		[
			71744
		]
	],
	"./diagnostic/hi.resource.json": [
		87097,
		[
			87097
		]
	],
	"./diagnostic/km.resource.json": [
		43532,
		[
			43532
		]
	],
	"./diagnostic/kn.resource.json": [
		14459,
		[
			14459
		]
	],
	"./diagnostic/ml.resource.json": [
		32519,
		[
			32519
		]
	],
	"./diagnostic/mr.resource.json": [
		90785,
		[
			90785
		]
	],
	"./diagnostic/nl.resource.json": [
		83410,
		[
			83410
		]
	],
	"./diagnostic/pa.resource.json": [
		78841,
		[
			78841
		]
	],
	"./diagnostic/ta.resource.json": [
		43621,
		[
			43621
		]
	],
	"./diagnostic/te.resource.json": [
		37865,
		[
			37865
		]
	],
	"./diagnostic/vi.resource.json": [
		24507,
		[
			24507
		]
	],
	"./diagnostic/zh-CN.resource.json": [
		35224,
		[
			35224
		]
	],
	"./diagnostics/ar.resource.json": [
		57710,
		[
			57710
		]
	],
	"./diagnostics/bn.resource.json": [
		54547,
		[
			54547
		]
	],
	"./diagnostics/en.resource.json": [
		93542,
		[
			93542
		]
	],
	"./diagnostics/es.resource.json": [
		82567,
		[
			82567
		]
	],
	"./diagnostics/fr.resource.json": [
		9811,
		[
			9811
		]
	],
	"./diagnostics/gu.resource.json": [
		20703,
		[
			20703
		]
	],
	"./diagnostics/hi.resource.json": [
		50290,
		[
			50290
		]
	],
	"./diagnostics/km.resource.json": [
		94395,
		[
			94395
		]
	],
	"./diagnostics/kn.resource.json": [
		73740,
		[
			73740
		]
	],
	"./diagnostics/ml.resource.json": [
		74908,
		[
			74908
		]
	],
	"./diagnostics/mr.resource.json": [
		20930,
		[
			20930
		]
	],
	"./diagnostics/nl.resource.json": [
		52077,
		[
			52077
		]
	],
	"./diagnostics/pa.resource.json": [
		96418,
		[
			96418
		]
	],
	"./diagnostics/ta.resource.json": [
		15118,
		[
			15118
		]
	],
	"./diagnostics/te.resource.json": [
		82922,
		[
			82922
		]
	],
	"./diagnostics/vi.resource.json": [
		63020,
		[
			63020
		]
	],
	"./diagnostics/zh-CN.resource.json": [
		96245,
		[
			96245
		]
	],
	"./diet-kitchen/ar.resource.json": [
		51025,
		[
			51025
		]
	],
	"./diet-kitchen/bn.resource.json": [
		29616,
		[
			29616
		]
	],
	"./diet-kitchen/en.resource.json": [
		52977,
		[
			52977
		]
	],
	"./diet-kitchen/es.resource.json": [
		5464,
		[
			5464
		]
	],
	"./diet-kitchen/fr.resource.json": [
		73792,
		[
			73792
		]
	],
	"./diet-kitchen/gu.resource.json": [
		1156,
		[
			1156
		]
	],
	"./diet-kitchen/hi.resource.json": [
		34333,
		[
			34333
		]
	],
	"./diet-kitchen/km.resource.json": [
		68936,
		[
			68936
		]
	],
	"./diet-kitchen/kn.resource.json": [
		54055,
		[
			54055
		]
	],
	"./diet-kitchen/ml.resource.json": [
		73963,
		[
			73963
		]
	],
	"./diet-kitchen/mr.resource.json": [
		71261,
		[
			71261
		]
	],
	"./diet-kitchen/nl.resource.json": [
		65878,
		[
			65878
		]
	],
	"./diet-kitchen/pa.resource.json": [
		15741,
		[
			15741
		]
	],
	"./diet-kitchen/ta.resource.json": [
		17009,
		[
			17009
		]
	],
	"./diet-kitchen/te.resource.json": [
		25037,
		[
			25037
		]
	],
	"./diet-kitchen/vi.resource.json": [
		31527,
		[
			31527
		]
	],
	"./diet-kitchen/zh-CN.resource.json": [
		76196,
		[
			76196
		]
	],
	"./dms/ar.resource.json": [
		85542,
		[
			85542
		]
	],
	"./dms/bn.resource.json": [
		21851,
		[
			21851
		]
	],
	"./dms/en.resource.json": [
		18606,
		[
			18606
		]
	],
	"./dms/es.resource.json": [
		42271,
		[
			42271
		]
	],
	"./dms/fr.resource.json": [
		9931,
		[
			9931
		]
	],
	"./dms/gu.resource.json": [
		18743,
		[
			18743
		]
	],
	"./dms/hi.resource.json": [
		59306,
		[
			59306
		]
	],
	"./dms/km.resource.json": [
		61235,
		[
			61235
		]
	],
	"./dms/kn.resource.json": [
		45188,
		[
			45188
		]
	],
	"./dms/ml.resource.json": [
		77172,
		[
			77172
		]
	],
	"./dms/mr.resource.json": [
		37162,
		[
			37162
		]
	],
	"./dms/nl.resource.json": [
		46085,
		[
			46085
		]
	],
	"./dms/pa.resource.json": [
		58778,
		[
			58778
		]
	],
	"./dms/ta.resource.json": [
		19558,
		[
			19558
		]
	],
	"./dms/te.resource.json": [
		33922,
		[
			33922
		]
	],
	"./dms/vi.resource.json": [
		83060,
		[
			83060
		]
	],
	"./dms/zh-CN.resource.json": [
		98397,
		[
			98397
		]
	],
	"./emr/ar.resource.json": [
		71298,
		[
			71298
		]
	],
	"./emr/bn.resource.json": [
		55935,
		[
			55935
		]
	],
	"./emr/en.resource.json": [
		48778,
		[
			48778
		]
	],
	"./emr/es.resource.json": [
		63523,
		[
			63523
		]
	],
	"./emr/fr.resource.json": [
		19823,
		[
			19823
		]
	],
	"./emr/gu.resource.json": [
		3779,
		[
			3779
		]
	],
	"./emr/hi.resource.json": [
		85174,
		[
			85174
		]
	],
	"./emr/km.resource.json": [
		52151,
		[
			52151
		]
	],
	"./emr/kn.resource.json": [
		16152,
		[
			16152
		]
	],
	"./emr/ml.resource.json": [
		83872,
		[
			83872
		]
	],
	"./emr/mr.resource.json": [
		6350,
		[
			6350
		]
	],
	"./emr/nl.resource.json": [
		55329,
		[
			55329
		]
	],
	"./emr/pa.resource.json": [
		4662,
		[
			4662
		]
	],
	"./emr/ta.resource.json": [
		66794,
		[
			66794
		]
	],
	"./emr/te.resource.json": [
		99310,
		[
			99310
		]
	],
	"./emr/vi.resource.json": [
		89752,
		[
			89752
		]
	],
	"./emr/zh-CN.resource.json": [
		67745,
		[
			67745
		]
	],
	"./en-console.resource.json": [
		14717,
		[
			14717
		]
	],
	"./en-cs.resource.json": [
		33483,
		[
			55864
		]
	],
	"./en-ne.resource.json": [
		97321,
		[
			97321
		]
	],
	"./en.resource.json": [
		40345,
		[
			40345
		]
	],
	"./es.resource.json": [
		36112,
		[
			36112
		]
	],
	"./facility-management/ar.resource.json": [
		85565,
		[
			85565
		]
	],
	"./facility-management/bn.resource.json": [
		23956,
		[
			23956
		]
	],
	"./facility-management/en.resource.json": [
		42413,
		[
			42413
		]
	],
	"./facility-management/es.resource.json": [
		49612,
		[
			49612
		]
	],
	"./facility-management/fr.resource.json": [
		78356,
		[
			78356
		]
	],
	"./facility-management/gu.resource.json": [
		73584,
		[
			73584
		]
	],
	"./facility-management/hi.resource.json": [
		13065,
		[
			13065
		]
	],
	"./facility-management/km.resource.json": [
		12764,
		[
			12764
		]
	],
	"./facility-management/kn.resource.json": [
		51403,
		[
			51403
		]
	],
	"./facility-management/ml.resource.json": [
		36695,
		[
			36695
		]
	],
	"./facility-management/mr.resource.json": [
		24945,
		[
			24945
		]
	],
	"./facility-management/nl.resource.json": [
		70146,
		[
			70146
		]
	],
	"./facility-management/pa.resource.json": [
		52585,
		[
			52585
		]
	],
	"./facility-management/ta.resource.json": [
		6261,
		[
			6261
		]
	],
	"./facility-management/te.resource.json": [
		56857,
		[
			56857
		]
	],
	"./facility-management/vi.resource.json": [
		73131,
		[
			73131
		]
	],
	"./facility-management/zh-CN.resource.json": [
		47496,
		[
			47496
		]
	],
	"./feedback/ar.resource.json": [
		81449,
		[
			81449
		]
	],
	"./feedback/bn.resource.json": [
		64248,
		[
			64248
		]
	],
	"./feedback/en.resource.json": [
		9017,
		[
			9017
		]
	],
	"./feedback/es.resource.json": [
		12336,
		[
			12336
		]
	],
	"./feedback/fr.resource.json": [
		25336,
		[
			25336
		]
	],
	"./feedback/gu.resource.json": [
		75356,
		[
			75356
		]
	],
	"./feedback/hi.resource.json": [
		56629,
		[
			56629
		]
	],
	"./feedback/km.resource.json": [
		68192,
		[
			68192
		]
	],
	"./feedback/kn.resource.json": [
		40287,
		[
			40287
		]
	],
	"./feedback/ml.resource.json": [
		35203,
		[
			35203
		]
	],
	"./feedback/mr.resource.json": [
		74597,
		[
			74597
		]
	],
	"./feedback/nl.resource.json": [
		39502,
		[
			39502
		]
	],
	"./feedback/pa.resource.json": [
		16661,
		[
			16661
		]
	],
	"./feedback/ta.resource.json": [
		1686,
		[
			79305
		]
	],
	"./feedback/te.resource.json": [
		85061,
		[
			85061
		]
	],
	"./feedback/vi.resource.json": [
		99183,
		[
			99183
		]
	],
	"./feedback/zh-CN.resource.json": [
		34860,
		[
			34860
		]
	],
	"./form-template-engine/ar.resource.json": [
		65922,
		[
			65922
		]
	],
	"./form-template-engine/bn.resource.json": [
		40319,
		[
			40319
		]
	],
	"./form-template-engine/en.resource.json": [
		82058,
		[
			82058
		]
	],
	"./form-template-engine/es.resource.json": [
		53923,
		[
			53923
		]
	],
	"./form-template-engine/fr.resource.json": [
		74703,
		[
			74703
		]
	],
	"./form-template-engine/gu.resource.json": [
		12835,
		[
			12835
		]
	],
	"./form-template-engine/hi.resource.json": [
		70134,
		[
			70134
		]
	],
	"./form-template-engine/km.resource.json": [
		51447,
		[
			51447
		]
	],
	"./form-template-engine/kn.resource.json": [
		64280,
		[
			64280
		]
	],
	"./form-template-engine/ml.resource.json": [
		15648,
		[
			15648
		]
	],
	"./form-template-engine/mr.resource.json": [
		18574,
		[
			18574
		]
	],
	"./form-template-engine/nl.resource.json": [
		59073,
		[
			59073
		]
	],
	"./form-template-engine/pa.resource.json": [
		90230,
		[
			90230
		]
	],
	"./form-template-engine/ta.resource.json": [
		25418,
		[
			25418
		]
	],
	"./form-template-engine/te.resource.json": [
		57614,
		[
			57614
		]
	],
	"./form-template-engine/vi.resource.json": [
		54232,
		[
			54232
		]
	],
	"./form-template-engine/zh-CN.resource.json": [
		92385,
		[
			92385
		]
	],
	"./formBuilder/ar.resource.json": [
		29023,
		[
			29023
		]
	],
	"./formBuilder/bn.resource.json": [
		15578,
		[
			15578
		]
	],
	"./formBuilder/en.resource.json": [
		92847,
		[
			92847
		]
	],
	"./formBuilder/es.resource.json": [
		79262,
		[
			79262
		]
	],
	"./formBuilder/fr.resource.json": [
		86738,
		[
			86738
		]
	],
	"./formBuilder/gu.resource.json": [
		31746,
		[
			31746
		]
	],
	"./formBuilder/hi.resource.json": [
		33551,
		[
			33551
		]
	],
	"./formBuilder/km.resource.json": [
		750,
		[
			750
		]
	],
	"./formBuilder/kn.resource.json": [
		42313,
		[
			42313
		]
	],
	"./formBuilder/ml.resource.json": [
		97445,
		[
			97445
		]
	],
	"./formBuilder/mr.resource.json": [
		83043,
		[
			83043
		]
	],
	"./formBuilder/nl.resource.json": [
		73556,
		[
			73556
		]
	],
	"./formBuilder/pa.resource.json": [
		85007,
		[
			85007
		]
	],
	"./formBuilder/ta.resource.json": [
		58203,
		[
			58203
		]
	],
	"./formBuilder/te.resource.json": [
		39511,
		[
			39511
		]
	],
	"./formBuilder/vi.resource.json": [
		1877,
		[
			1877
		]
	],
	"./formBuilder/zh-CN.resource.json": [
		6550,
		[
			6550
		]
	],
	"./fr.resource.json": [
		99480,
		[
			99480
		]
	],
	"./gu-console.resource.json": [
		18684,
		[
			18684
		]
	],
	"./gu.resource.json": [
		49340,
		[
			49340
		]
	],
	"./helpdeskmgmt/ar.resource.json": [
		57025,
		[
			57025
		]
	],
	"./helpdeskmgmt/bn.resource.json": [
		49024,
		[
			49024
		]
	],
	"./helpdeskmgmt/en.resource.json": [
		20481,
		[
			20481
		]
	],
	"./helpdeskmgmt/es.resource.json": [
		21448,
		[
			21448
		]
	],
	"./helpdeskmgmt/fr.resource.json": [
		43376,
		[
			43376
		]
	],
	"./helpdeskmgmt/gu.resource.json": [
		58836,
		[
			58836
		]
	],
	"./helpdeskmgmt/hi.resource.json": [
		96781,
		[
			96781
		]
	],
	"./helpdeskmgmt/km.resource.json": [
		87192,
		[
			87192
		]
	],
	"./helpdeskmgmt/kn.resource.json": [
		39543,
		[
			39543
		]
	],
	"./helpdeskmgmt/ml.resource.json": [
		93083,
		[
			93083
		]
	],
	"./helpdeskmgmt/mr.resource.json": [
		54669,
		[
			54669
		]
	],
	"./helpdeskmgmt/nl.resource.json": [
		90534,
		[
			90534
		]
	],
	"./helpdeskmgmt/pa.resource.json": [
		13,
		[
			13
		]
	],
	"./helpdeskmgmt/ta.resource.json": [
		70273,
		[
			70273
		]
	],
	"./helpdeskmgmt/te.resource.json": [
		86013,
		[
			86013
		]
	],
	"./helpdeskmgmt/vi.resource.json": [
		83415,
		[
			83415
		]
	],
	"./helpdeskmgmt/zh-CN.resource.json": [
		38804,
		[
			38804
		]
	],
	"./hi.resource.json": [
		35349,
		[
			35349
		]
	],
	"./house-keeping/ar.resource.json": [
		73880,
		[
			73880
		]
	],
	"./house-keeping/bn.resource.json": [
		35641,
		[
			35641
		]
	],
	"./house-keeping/en.resource.json": [
		59288,
		[
			59288
		]
	],
	"./house-keeping/es.resource.json": [
		91601,
		[
			91601
		]
	],
	"./house-keeping/fr.resource.json": [
		94665,
		[
			94665
		]
	],
	"./house-keeping/gu.resource.json": [
		96281,
		[
			96281
		]
	],
	"./house-keeping/hi.resource.json": [
		16744,
		[
			16744
		]
	],
	"./house-keeping/km.resource.json": [
		2149,
		[
			2149
		]
	],
	"./house-keeping/kn.resource.json": [
		48362,
		[
			48362
		]
	],
	"./house-keeping/ml.resource.json": [
		56546,
		[
			56546
		]
	],
	"./house-keeping/mr.resource.json": [
		10524,
		[
			10524
		]
	],
	"./house-keeping/nl.resource.json": [
		86583,
		[
			86583
		]
	],
	"./house-keeping/pa.resource.json": [
		78408,
		[
			78408
		]
	],
	"./house-keeping/ta.resource.json": [
		1252,
		[
			1252
		]
	],
	"./house-keeping/te.resource.json": [
		41680,
		[
			41680
		]
	],
	"./house-keeping/vi.resource.json": [
		77350,
		[
			77350
		]
	],
	"./house-keeping/zh-CN.resource.json": [
		56611,
		[
			56611
		]
	],
	"./insurance/ar.resource.json": [
		93578,
		[
			93578
		]
	],
	"./insurance/bn.resource.json": [
		99639,
		[
			99639
		]
	],
	"./insurance/en.resource.json": [
		33090,
		[
			33090
		]
	],
	"./insurance/es.resource.json": [
		88171,
		[
			88171
		]
	],
	"./insurance/fr.resource.json": [
		17463,
		[
			17463
		]
	],
	"./insurance/gu.resource.json": [
		44203,
		[
			44203
		]
	],
	"./insurance/hi.resource.json": [
		94206,
		[
			94206
		]
	],
	"./insurance/km.resource.json": [
		18815,
		[
			18815
		]
	],
	"./insurance/kn.resource.json": [
		17824,
		[
			17824
		]
	],
	"./insurance/ml.resource.json": [
		13032,
		[
			13032
		]
	],
	"./insurance/mr.resource.json": [
		20646,
		[
			20646
		]
	],
	"./insurance/nl.resource.json": [
		53769,
		[
			53769
		]
	],
	"./insurance/pa.resource.json": [
		70238,
		[
			70238
		]
	],
	"./insurance/ta.resource.json": [
		16178,
		[
			16178
		]
	],
	"./insurance/te.resource.json": [
		29974,
		[
			29974
		]
	],
	"./insurance/vi.resource.json": [
		48016,
		[
			48016
		]
	],
	"./insurance/zh-CN.resource.json": [
		29913,
		[
			29913
		]
	],
	"./integrator/ar.resource.json": [
		98283,
		[
			98283
		]
	],
	"./integrator/bn.resource.json": [
		93006,
		[
			93006
		]
	],
	"./integrator/en.resource.json": [
		22331,
		[
			22331
		]
	],
	"./integrator/es.resource.json": [
		78994,
		[
			78994
		]
	],
	"./integrator/fr.resource.json": [
		41273,
		[
			63654
		]
	],
	"./integrator/gu.resource.json": [
		13854,
		[
			13854
		]
	],
	"./integrator/hi.resource.json": [
		98155,
		[
			98155
		]
	],
	"./integrator/km.resource.json": [
		43618,
		[
			43618
		]
	],
	"./integrator/kn.resource.json": [
		53149,
		[
			53149
		]
	],
	"./integrator/ml.resource.json": [
		63345,
		[
			63345
		]
	],
	"./integrator/mr.resource.json": [
		60471,
		[
			60471
		]
	],
	"./integrator/nl.resource.json": [
		75536,
		[
			75536
		]
	],
	"./integrator/pa.resource.json": [
		49051,
		[
			49051
		]
	],
	"./integrator/ta.resource.json": [
		24079,
		[
			24079
		]
	],
	"./integrator/te.resource.json": [
		39443,
		[
			39443
		]
	],
	"./integrator/vi.resource.json": [
		61801,
		[
			61801
		]
	],
	"./integrator/zh-CN.resource.json": [
		68762,
		[
			68762
		]
	],
	"./inventory-management/ar.resource.json": [
		75502,
		[
			75502
		]
	],
	"./inventory-management/bn.resource.json": [
		72339,
		[
			72339
		]
	],
	"./inventory-management/en.resource.json": [
		94982,
		[
			94982
		]
	],
	"./inventory-management/es.resource.json": [
		84007,
		[
			84007
		]
	],
	"./inventory-management/fr.resource.json": [
		27603,
		[
			27603
		]
	],
	"./inventory-management/gu.resource.json": [
		38495,
		[
			38495
		]
	],
	"./inventory-management/hi.resource.json": [
		68082,
		[
			68082
		]
	],
	"./inventory-management/km.resource.json": [
		12187,
		[
			12187
		]
	],
	"./inventory-management/kn.resource.json": [
		75180,
		[
			75180
		]
	],
	"./inventory-management/ml.resource.json": [
		92700,
		[
			92700
		]
	],
	"./inventory-management/mr.resource.json": [
		38722,
		[
			38722
		]
	],
	"./inventory-management/nl.resource.json": [
		69869,
		[
			69869
		]
	],
	"./inventory-management/pa.resource.json": [
		14210,
		[
			14210
		]
	],
	"./inventory-management/ta.resource.json": [
		32910,
		[
			32910
		]
	],
	"./inventory-management/te.resource.json": [
		714,
		[
			714
		]
	],
	"./inventory-management/vi.resource.json": [
		80812,
		[
			80812
		]
	],
	"./inventory-management/zh-CN.resource.json": [
		62741,
		[
			62741
		]
	],
	"./km.resource.json": [
		4160,
		[
			4160
		]
	],
	"./kn-console.resource.json": [
		62319,
		[
			62319
		]
	],
	"./kn.resource.json": [
		50303,
		[
			50303
		]
	],
	"./kx-order/ar.resource.json": [
		25428,
		[
			25428
		]
	],
	"./kx-order/bn.resource.json": [
		37754,
		[
			15373
		]
	],
	"./kx-order/en.resource.json": [
		18484,
		[
			18484
		]
	],
	"./kx-order/es.resource.json": [
		53797,
		[
			53797
		]
	],
	"./kx-order/fr.resource.json": [
		86237,
		[
			86237
		]
	],
	"./kx-order/gu.resource.json": [
		84197,
		[
			84197
		]
	],
	"./kx-order/hi.resource.json": [
		19540,
		[
			19540
		]
	],
	"./kx-order/km.resource.json": [
		19801,
		[
			19801
		]
	],
	"./kx-order/kn.resource.json": [
		57182,
		[
			57182
		]
	],
	"./kx-order/ml.resource.json": [
		494,
		[
			494
		]
	],
	"./kx-order/mr.resource.json": [
		78976,
		[
			78976
		]
	],
	"./kx-order/nl.resource.json": [
		24355,
		[
			24355
		]
	],
	"./kx-order/pa.resource.json": [
		76868,
		[
			76868
		]
	],
	"./kx-order/ta.resource.json": [
		54024,
		[
			54024
		]
	],
	"./kx-order/te.resource.json": [
		56764,
		[
			56764
		]
	],
	"./kx-order/vi.resource.json": [
		18090,
		[
			18090
		]
	],
	"./kx-order/zh-CN.resource.json": [
		29239,
		[
			29239
		]
	],
	"./kxinsights/en.resource.json": [
		63564,
		[
			63564
		]
	],
	"./linen-laundry/ar.resource.json": [
		64098,
		[
			64098
		]
	],
	"./linen-laundry/bn.resource.json": [
		60876,
		[
			60876
		]
	],
	"./linen-laundry/en.resource.json": [
		80234,
		[
			80234
		]
	],
	"./linen-laundry/es.resource.json": [
		52099,
		[
			52099
		]
	],
	"./linen-laundry/fr.resource.json": [
		72879,
		[
			72879
		]
	],
	"./linen-laundry/gu.resource.json": [
		11011,
		[
			11011
		]
	],
	"./linen-laundry/hi.resource.json": [
		68310,
		[
			68310
		]
	],
	"./linen-laundry/km.resource.json": [
		49623,
		[
			49623
		]
	],
	"./linen-laundry/kn.resource.json": [
		78808,
		[
			78808
		]
	],
	"./linen-laundry/ml.resource.json": [
		13824,
		[
			13824
		]
	],
	"./linen-laundry/mr.resource.json": [
		16750,
		[
			16750
		]
	],
	"./linen-laundry/nl.resource.json": [
		57249,
		[
			57249
		]
	],
	"./linen-laundry/pa.resource.json": [
		4758,
		[
			4758
		]
	],
	"./linen-laundry/ta.resource.json": [
		23594,
		[
			23594
		]
	],
	"./linen-laundry/te.resource.json": [
		55790,
		[
			55790
		]
	],
	"./linen-laundry/vi.resource.json": [
		52408,
		[
			52408
		]
	],
	"./linen-laundry/zh-CN.resource.json": [
		49249,
		[
			49249
		]
	],
	"./master-management/ar.resource.json": [
		50500,
		[
			50500
		]
	],
	"./master-management/en.resource.json": [
		78756,
		[
			78756
		]
	],
	"./master-management/es.resource.json": [
		90741,
		[
			90741
		]
	],
	"./master-management/fr.resource.json": [
		98765,
		[
			98765
		]
	],
	"./master-management/gu.resource.json": [
		50325,
		[
			50325
		]
	],
	"./master-management/hi.resource.json": [
		45636,
		[
			45636
		]
	],
	"./misbuilder/ar.resource.json": [
		48792,
		[
			48792
		]
	],
	"./misbuilder/bn.resource.json": [
		73305,
		[
			73305
		]
	],
	"./misbuilder/en.resource.json": [
		99128,
		[
			99128
		]
	],
	"./misbuilder/es.resource.json": [
		65649,
		[
			65649
		]
	],
	"./misbuilder/fr.resource.json": [
		96553,
		[
			96553
		]
	],
	"./misbuilder/gu.resource.json": [
		71001,
		[
			71001
		]
	],
	"./misbuilder/hi.resource.json": [
		20104,
		[
			20104
		]
	],
	"./misbuilder/km.resource.json": [
		35013,
		[
			35013
		]
	],
	"./misbuilder/kn.resource.json": [
		40554,
		[
			40554
		]
	],
	"./misbuilder/ml.resource.json": [
		17794,
		[
			17794
		]
	],
	"./misbuilder/mr.resource.json": [
		28636,
		[
			28636
		]
	],
	"./misbuilder/nl.resource.json": [
		21751,
		[
			21751
		]
	],
	"./misbuilder/pa.resource.json": [
		48232,
		[
			48232
		]
	],
	"./misbuilder/ta.resource.json": [
		47172,
		[
			47172
		]
	],
	"./misbuilder/te.resource.json": [
		90832,
		[
			90832
		]
	],
	"./misbuilder/vi.resource.json": [
		73574,
		[
			73574
		]
	],
	"./misbuilder/zh-CN.resource.json": [
		24803,
		[
			24803
		]
	],
	"./misreports/ar.resource.json": [
		55656,
		[
			55656
		]
	],
	"./misreports/bn.resource.json": [
		65737,
		[
			65737
		]
	],
	"./misreports/en.resource.json": [
		55752,
		[
			55752
		]
	],
	"./misreports/es.resource.json": [
		91233,
		[
			91233
		]
	],
	"./misreports/fr.resource.json": [
		45401,
		[
			45401
		]
	],
	"./misreports/gu.resource.json": [
		88521,
		[
			88521
		]
	],
	"./misreports/hi.resource.json": [
		42648,
		[
			42648
		]
	],
	"./misreports/km.resource.json": [
		40917,
		[
			40917
		]
	],
	"./misreports/kn.resource.json": [
		41722,
		[
			41722
		]
	],
	"./misreports/ml.resource.json": [
		1106,
		[
			1106
		]
	],
	"./misreports/mr.resource.json": [
		88300,
		[
			88300
		]
	],
	"./misreports/nl.resource.json": [
		66567,
		[
			66567
		]
	],
	"./misreports/pa.resource.json": [
		43640,
		[
			43640
		]
	],
	"./misreports/ta.resource.json": [
		79796,
		[
			79796
		]
	],
	"./misreports/te.resource.json": [
		87392,
		[
			87392
		]
	],
	"./misreports/vi.resource.json": [
		42198,
		[
			42198
		]
	],
	"./misreports/zh-CN.resource.json": [
		8243,
		[
			8243
		]
	],
	"./ml-console.resource.json": [
		49427,
		[
			49427
		]
	],
	"./ml.resource.json": [
		76195,
		[
			76195
		]
	],
	"./mr-console.resource.json": [
		17209,
		[
			17209
		]
	],
	"./mr.resource.json": [
		90597,
		[
			90597
		]
	],
	"./mrd/ar.resource.json": [
		38895,
		[
			38895
		]
	],
	"./mrd/bn.resource.json": [
		84458,
		[
			84458
		]
	],
	"./mrd/en.resource.json": [
		43519,
		[
			43519
		]
	],
	"./mrd/es.resource.json": [
		19854,
		[
			19854
		]
	],
	"./mrd/fr.resource.json": [
		49634,
		[
			49634
		]
	],
	"./mrd/gu.resource.json": [
		37490,
		[
			37490
		]
	],
	"./mrd/hi.resource.json": [
		77279,
		[
			77279
		]
	],
	"./mrd/km.resource.json": [
		89886,
		[
			89886
		]
	],
	"./mrd/kn.resource.json": [
		39590,
		[
			39590
		]
	],
	"./mrd/ml.resource.json": [
		34453,
		[
			34453
		]
	],
	"./mrd/mr.resource.json": [
		38515,
		[
			38515
		]
	],
	"./mrd/nl.resource.json": [
		52324,
		[
			52324
		]
	],
	"./mrd/pa.resource.json": [
		93151,
		[
			93151
		]
	],
	"./mrd/ta.resource.json": [
		17963,
		[
			17963
		]
	],
	"./mrd/te.resource.json": [
		31623,
		[
			31623
		]
	],
	"./mrd/vi.resource.json": [
		85541,
		[
			85541
		]
	],
	"./nhm-reports/ar.resource.json": [
		90537,
		[
			90537
		]
	],
	"./nhm-reports/bn.resource.json": [
		17528,
		[
			17528
		]
	],
	"./nhm-reports/en.resource.json": [
		50681,
		[
			50681
		]
	],
	"./nhm-reports/es.resource.json": [
		28528,
		[
			28528
		]
	],
	"./nhm-reports/fr.resource.json": [
		4344,
		[
			4344
		]
	],
	"./nhm-reports/gu.resource.json": [
		60412,
		[
			60412
		]
	],
	"./nhm-reports/hi.resource.json": [
		53781,
		[
			53781
		]
	],
	"./nhm-reports/km.resource.json": [
		72672,
		[
			72672
		]
	],
	"./nhm-reports/kn.resource.json": [
		57311,
		[
			57311
		]
	],
	"./nhm-reports/ml.resource.json": [
		58787,
		[
			58787
		]
	],
	"./nhm-reports/mr.resource.json": [
		7077,
		[
			7077
		]
	],
	"./nhm-reports/nl.resource.json": [
		82606,
		[
			82606
		]
	],
	"./nhm-reports/pa.resource.json": [
		18165,
		[
			18165
		]
	],
	"./nhm-reports/ta.resource.json": [
		64489,
		[
			64489
		]
	],
	"./nhm-reports/te.resource.json": [
		84869,
		[
			84869
		]
	],
	"./nhm-reports/vi.resource.json": [
		84943,
		[
			84943
		]
	],
	"./nl-console.resource.json": [
		91026,
		[
			91026
		]
	],
	"./nl.resource.json": [
		91086,
		[
			91086
		]
	],
	"./opsmgmt/en.resource.json": [
		63723,
		[
			63723
		]
	],
	"./optical/ar.resource.json": [
		21390,
		[
			21390
		]
	],
	"./optical/bn.resource.json": [
		34931,
		[
			34931
		]
	],
	"./optical/en.resource.json": [
		17510,
		[
			17510
		]
	],
	"./optical/es.resource.json": [
		64007,
		[
			64007
		]
	],
	"./optical/fr.resource.json": [
		21491,
		[
			21491
		]
	],
	"./optical/gu.resource.json": [
		54687,
		[
			54687
		]
	],
	"./optical/hi.resource.json": [
		46450,
		[
			46450
		]
	],
	"./optical/km.resource.json": [
		93851,
		[
			93851
		]
	],
	"./optical/kn.resource.json": [
		22924,
		[
			22924
		]
	],
	"./optical/ml.resource.json": [
		73884,
		[
			73884
		]
	],
	"./optical/mr.resource.json": [
		63042,
		[
			63042
		]
	],
	"./optical/nl.resource.json": [
		94413,
		[
			94413
		]
	],
	"./optical/pa.resource.json": [
		3138,
		[
			3138
		]
	],
	"./optical/ta.resource.json": [
		72142,
		[
			72142
		]
	],
	"./optical/te.resource.json": [
		39626,
		[
			39626
		]
	],
	"./optical/vi.resource.json": [
		57612,
		[
			57612
		]
	],
	"./order/ar.resource.json": [
		75310,
		[
			75310
		]
	],
	"./order/bn.resource.json": [
		88499,
		[
			88499
		]
	],
	"./order/en.resource.json": [
		11142,
		[
			11142
		]
	],
	"./order/es.resource.json": [
		167,
		[
			167
		]
	],
	"./order/fr.resource.json": [
		27411,
		[
			27411
		]
	],
	"./order/gu.resource.json": [
		54655,
		[
			54655
		]
	],
	"./order/hi.resource.json": [
		84242,
		[
			84242
		]
	],
	"./order/km.resource.json": [
		28347,
		[
			28347
		]
	],
	"./order/kn.resource.json": [
		91340,
		[
			91340
		]
	],
	"./order/ml.resource.json": [
		8860,
		[
			8860
		]
	],
	"./order/mr.resource.json": [
		54882,
		[
			54882
		]
	],
	"./order/nl.resource.json": [
		86029,
		[
			86029
		]
	],
	"./order/pa.resource.json": [
		14018,
		[
			14018
		]
	],
	"./order/ta.resource.json": [
		49070,
		[
			49070
		]
	],
	"./order/te.resource.json": [
		16874,
		[
			16874
		]
	],
	"./order/vi.resource.json": [
		80620,
		[
			80620
		]
	],
	"./ot/ar.resource.json": [
		23257,
		[
			23257
		]
	],
	"./ot/bn.resource.json": [
		33608,
		[
			33608
		]
	],
	"./ot/en.resource.json": [
		59945,
		[
			59945
		]
	],
	"./ot/es.resource.json": [
		70752,
		[
			70752
		]
	],
	"./ot/fr.resource.json": [
		33512,
		[
			33512
		]
	],
	"./ot/gu.resource.json": [
		78476,
		[
			78476
		]
	],
	"./ot/hi.resource.json": [
		42629,
		[
			42629
		]
	],
	"./ot/km.resource.json": [
		90896,
		[
			90896
		]
	],
	"./ot/kn.resource.json": [
		88911,
		[
			88911
		]
	],
	"./ot/ml.resource.json": [
		61555,
		[
			61555
		]
	],
	"./ot/mr.resource.json": [
		64981,
		[
			64981
		]
	],
	"./ot/nl.resource.json": [
		2654,
		[
			2654
		]
	],
	"./ot/pa.resource.json": [
		39173,
		[
			39173
		]
	],
	"./ot/ta.resource.json": [
		90745,
		[
			90745
		]
	],
	"./ot/te.resource.json": [
		79989,
		[
			79989
		]
	],
	"./ot/vi.resource.json": [
		37311,
		[
			37311
		]
	],
	"./pa-console.resource.json": [
		53289,
		[
			53289
		]
	],
	"./pa.resource.json": [
		61845,
		[
			61845
		]
	],
	"./patient-registration/ar.resource.json": [
		79,
		[
			79
		]
	],
	"./patient-registration/bn.resource.json": [
		91786,
		[
			91786
		]
	],
	"./patient-registration/en.resource.json": [
		81407,
		[
			81407
		]
	],
	"./patient-registration/es.resource.json": [
		97134,
		[
			97134
		]
	],
	"./patient-registration/fr.resource.json": [
		95650,
		[
			95650
		]
	],
	"./patient-registration/gu.resource.json": [
		89010,
		[
			89010
		]
	],
	"./patient-registration/hi.resource.json": [
		7327,
		[
			7327
		]
	],
	"./patient-registration/km.resource.json": [
		27710,
		[
			27710
		]
	],
	"./patient-registration/kn.resource.json": [
		62713,
		[
			62713
		]
	],
	"./patient-registration/ml.resource.json": [
		83061,
		[
			83061
		]
	],
	"./patient-registration/mr.resource.json": [
		70451,
		[
			70451
		]
	],
	"./patient-registration/nl.resource.json": [
		99364,
		[
			99364
		]
	],
	"./patient-registration/pa.resource.json": [
		47391,
		[
			47391
		]
	],
	"./patient-registration/ta.resource.json": [
		1291,
		[
			1291
		]
	],
	"./patient-registration/te.resource.json": [
		52551,
		[
			52551
		]
	],
	"./patient-registration/vi.resource.json": [
		47845,
		[
			47845
		]
	],
	"./payment-gateway/ar.resource.json": [
		8795,
		[
			8795
		]
	],
	"./payment-gateway/bn.resource.json": [
		54110,
		[
			54110
		]
	],
	"./payment-gateway/en.resource.json": [
		32651,
		[
			32651
		]
	],
	"./payment-gateway/es.resource.json": [
		30210,
		[
			30210
		]
	],
	"./payment-gateway/fr.resource.json": [
		32758,
		[
			32758
		]
	],
	"./payment-gateway/gu.resource.json": [
		57230,
		[
			57230
		]
	],
	"./payment-gateway/hi.resource.json": [
		31035,
		[
			31035
		]
	],
	"./payment-gateway/km.resource.json": [
		83634,
		[
			83634
		]
	],
	"./payment-gateway/kn.resource.json": [
		32557,
		[
			32557
		]
	],
	"./payment-gateway/ml.resource.json": [
		3617,
		[
			3617
		]
	],
	"./payment-gateway/mr.resource.json": [
		75495,
		[
			75495
		]
	],
	"./payment-gateway/nl.resource.json": [
		60192,
		[
			60192
		]
	],
	"./payment-gateway/pa.resource.json": [
		50731,
		[
			50731
		]
	],
	"./payment-gateway/ta.resource.json": [
		50847,
		[
			50847
		]
	],
	"./payment-gateway/te.resource.json": [
		5507,
		[
			5507
		]
	],
	"./payment-gateway/vi.resource.json": [
		93625,
		[
			93625
		]
	],
	"./payment/ar.resource.json": [
		95480,
		[
			95480
		]
	],
	"./payment/bn.resource.json": [
		25465,
		[
			25465
		]
	],
	"./payment/en.resource.json": [
		92312,
		[
			92312
		]
	],
	"./payment/es.resource.json": [
		24689,
		[
			24689
		]
	],
	"./payment/fr.resource.json": [
		81673,
		[
			81673
		]
	],
	"./payment/gu.resource.json": [
		7769,
		[
			7769
		]
	],
	"./payment/hi.resource.json": [
		80360,
		[
			80360
		]
	],
	"./payment/km.resource.json": [
		70437,
		[
			70437
		]
	],
	"./payment/kn.resource.json": [
		41290,
		[
			41290
		]
	],
	"./payment/ml.resource.json": [
		56834,
		[
			56834
		]
	],
	"./payment/mr.resource.json": [
		48732,
		[
			48732
		]
	],
	"./payment/nl.resource.json": [
		23383,
		[
			23383
		]
	],
	"./payment/pa.resource.json": [
		44744,
		[
			44744
		]
	],
	"./payment/ta.resource.json": [
		39236,
		[
			39236
		]
	],
	"./payment/te.resource.json": [
		50384,
		[
			50384
		]
	],
	"./payment/vi.resource.json": [
		80742,
		[
			80742
		]
	],
	"./pharmacy/ar.resource.json": [
		21435,
		[
			21435
		]
	],
	"./pharmacy/bn.resource.json": [
		89086,
		[
			89086
		]
	],
	"./pharmacy/en.resource.json": [
		2123,
		[
			2123
		]
	],
	"./pharmacy/es.resource.json": [
		87042,
		[
			87042
		]
	],
	"./pharmacy/fr.resource.json": [
		3094,
		[
			3094
		]
	],
	"./pharmacy/gu.resource.json": [
		66414,
		[
			66414
		]
	],
	"./pharmacy/hi.resource.json": [
		27323,
		[
			27323
		]
	],
	"./pharmacy/km.resource.json": [
		33650,
		[
			33650
		]
	],
	"./pharmacy/kn.resource.json": [
		47373,
		[
			47373
		]
	],
	"./pharmacy/ml.resource.json": [
		37473,
		[
			37473
		]
	],
	"./pharmacy/mr.resource.json": [
		67879,
		[
			67879
		]
	],
	"./pharmacy/nl.resource.json": [
		50784,
		[
			50784
		]
	],
	"./pharmacy/pa.resource.json": [
		20203,
		[
			20203
		]
	],
	"./pharmacy/ta.resource.json": [
		95391,
		[
			95391
		]
	],
	"./pharmacy/te.resource.json": [
		45027,
		[
			45027
		]
	],
	"./pharmacy/vi.resource.json": [
		60889,
		[
			60889
		]
	],
	"./pricing-engine/en.resource.json": [
		54637,
		[
			54637
		]
	],
	"./printengine/ar.resource.json": [
		95511,
		[
			95511
		]
	],
	"./printengine/bn.resource.json": [
		11138,
		[
			11138
		]
	],
	"./printengine/en.resource.json": [
		77687,
		[
			77687
		]
	],
	"./printengine/es.resource.json": [
		34166,
		[
			34166
		]
	],
	"./printengine/fr.resource.json": [
		55274,
		[
			55274
		]
	],
	"./printengine/gu.resource.json": [
		85338,
		[
			85338
		]
	],
	"./printengine/hi.resource.json": [
		69543,
		[
			69543
		]
	],
	"./printengine/km.resource.json": [
		28550,
		[
			28550
		]
	],
	"./printengine/kn.resource.json": [
		25537,
		[
			25537
		]
	],
	"./printengine/ml.resource.json": [
		74493,
		[
			74493
		]
	],
	"./printengine/mr.resource.json": [
		33323,
		[
			33323
		]
	],
	"./printengine/nl.resource.json": [
		29324,
		[
			29324
		]
	],
	"./printengine/pa.resource.json": [
		82023,
		[
			82023
		]
	],
	"./printengine/ta.resource.json": [
		29491,
		[
			29491
		]
	],
	"./printengine/te.resource.json": [
		655,
		[
			655
		]
	],
	"./printengine/vi.resource.json": [
		51325,
		[
			51325
		]
	],
	"./queue-management/ar.resource.json": [
		66807,
		[
			66807
		]
	],
	"./queue-management/bn.resource.json": [
		24866,
		[
			24866
		]
	],
	"./queue-management/en.resource.json": [
		28823,
		[
			28823
		]
	],
	"./queue-management/es.resource.json": [
		31702,
		[
			31702
		]
	],
	"./queue-management/fr.resource.json": [
		7306,
		[
			7306
		]
	],
	"./queue-management/gu.resource.json": [
		26458,
		[
			26458
		]
	],
	"./queue-management/hi.resource.json": [
		70823,
		[
			70823
		]
	],
	"./queue-management/km.resource.json": [
		21350,
		[
			21350
		]
	],
	"./queue-management/kn.resource.json": [
		9761,
		[
			9761
		]
	],
	"./queue-management/ml.resource.json": [
		93373,
		[
			93373
		]
	],
	"./queue-management/mr.resource.json": [
		12427,
		[
			12427
		]
	],
	"./queue-management/nl.resource.json": [
		49260,
		[
			49260
		]
	],
	"./queue-management/pa.resource.json": [
		21639,
		[
			21639
		]
	],
	"./queue-management/ta.resource.json": [
		28339,
		[
			28339
		]
	],
	"./queue-management/te.resource.json": [
		36079,
		[
			36079
		]
	],
	"./queue-management/vi.resource.json": [
		22205,
		[
			22205
		]
	],
	"./report-management/ar.resource.json": [
		9612,
		[
			9612
		]
	],
	"./report-management/bn.resource.json": [
		66645,
		[
			66645
		]
	],
	"./report-management/en.resource.json": [
		85308,
		[
			85308
		]
	],
	"./report-management/es.resource.json": [
		62845,
		[
			62845
		]
	],
	"./report-management/fr.resource.json": [
		38069,
		[
			38069
		]
	],
	"./report-management/gu.resource.json": [
		3517,
		[
			3517
		]
	],
	"./report-management/hi.resource.json": [
		9068,
		[
			9068
		]
	],
	"./report-management/km.resource.json": [
		25745,
		[
			25745
		]
	],
	"./report-management/kn.resource.json": [
		77622,
		[
			77622
		]
	],
	"./report-management/ml.resource.json": [
		17382,
		[
			17382
		]
	],
	"./report-management/mr.resource.json": [
		94600,
		[
			94600
		]
	],
	"./report-management/nl.resource.json": [
		19931,
		[
			19931
		]
	],
	"./report-management/pa.resource.json": [
		19324,
		[
			19324
		]
	],
	"./report-management/ta.resource.json": [
		74144,
		[
			74144
		]
	],
	"./report-management/te.resource.json": [
		82900,
		[
			82900
		]
	],
	"./report-management/vi.resource.json": [
		14258,
		[
			14258
		]
	],
	"./rule-engine/ar.resource.json": [
		20973,
		[
			20973
		]
	],
	"./rule-engine/bn.resource.json": [
		23876,
		[
			23876
		]
	],
	"./rule-engine/en.resource.json": [
		93853,
		[
			93853
		]
	],
	"./rule-engine/es.resource.json": [
		49724,
		[
			49724
		]
	],
	"./rule-engine/fr.resource.json": [
		24868,
		[
			24868
		]
	],
	"./rule-engine/gu.resource.json": [
		46624,
		[
			46624
		]
	],
	"./rule-engine/hi.resource.json": [
		22297,
		[
			22297
		]
	],
	"./rule-engine/km.resource.json": [
		74252,
		[
			74252
		]
	],
	"./rule-engine/kn.resource.json": [
		95035,
		[
			95035
		]
	],
	"./rule-engine/ml.resource.json": [
		12071,
		[
			12071
		]
	],
	"./rule-engine/mr.resource.json": [
		26017,
		[
			26017
		]
	],
	"./rule-engine/nl.resource.json": [
		85010,
		[
			85010
		]
	],
	"./rule-engine/pa.resource.json": [
		76985,
		[
			76985
		]
	],
	"./rule-engine/ta.resource.json": [
		57733,
		[
			57733
		]
	],
	"./rule-engine/te.resource.json": [
		65769,
		[
			65769
		]
	],
	"./rule-engine/vi.resource.json": [
		5083,
		[
			5083
		]
	],
	"./scheduler/ar.resource.json": [
		29651,
		[
			29651
		]
	],
	"./scheduler/bn.resource.json": [
		11846,
		[
			11846
		]
	],
	"./scheduler/en.resource.json": [
		58579,
		[
			58579
		]
	],
	"./scheduler/es.resource.json": [
		56026,
		[
			56026
		]
	],
	"./scheduler/fr.resource.json": [
		89102,
		[
			89102
		]
	],
	"./scheduler/gu.resource.json": [
		6342,
		[
			6342
		]
	],
	"./scheduler/hi.resource.json": [
		73459,
		[
			73459
		]
	],
	"./scheduler/km.resource.json": [
		83754,
		[
			83754
		]
	],
	"./scheduler/kn.resource.json": [
		37541,
		[
			37541
		]
	],
	"./scheduler/ml.resource.json": [
		53017,
		[
			53017
		]
	],
	"./scheduler/mr.resource.json": [
		45231,
		[
			45231
		]
	],
	"./scheduler/nl.resource.json": [
		19864,
		[
			19864
		]
	],
	"./scheduler/pa.resource.json": [
		83523,
		[
			83523
		]
	],
	"./scheduler/ta.resource.json": [
		17815,
		[
			17815
		]
	],
	"./scheduler/te.resource.json": [
		36507,
		[
			36507
		]
	],
	"./scheduler/vi.resource.json": [
		4673,
		[
			4673
		]
	],
	"./seriespattern/ar.resource.json": [
		25959,
		[
			25959
		]
	],
	"./seriespattern/bn.resource.json": [
		48658,
		[
			48658
		]
	],
	"./seriespattern/en.resource.json": [
		51175,
		[
			51175
		]
	],
	"./seriespattern/es.resource.json": [
		8070,
		[
			8070
		]
	],
	"./seriespattern/fr.resource.json": [
		78682,
		[
			78682
		]
	],
	"./seriespattern/gu.resource.json": [
		75946,
		[
			75946
		]
	],
	"./seriespattern/hi.resource.json": [
		53879,
		[
			53879
		]
	],
	"./seriespattern/km.resource.json": [
		81558,
		[
			81558
		]
	],
	"./seriespattern/kn.resource.json": [
		96817,
		[
			96817
		]
	],
	"./seriespattern/ml.resource.json": [
		63213,
		[
			63213
		]
	],
	"./seriespattern/mr.resource.json": [
		38491,
		[
			38491
		]
	],
	"./seriespattern/nl.resource.json": [
		5852,
		[
			5852
		]
	],
	"./seriespattern/pa.resource.json": [
		93239,
		[
			93239
		]
	],
	"./seriespattern/ta.resource.json": [
		80419,
		[
			80419
		]
	],
	"./seriespattern/te.resource.json": [
		30783,
		[
			30783
		]
	],
	"./seriespattern/vi.resource.json": [
		57325,
		[
			57325
		]
	],
	"./serviceworkflow/en.resource.json": [
		37900,
		[
			37900
		]
	],
	"./system-management/ar.resource.json": [
		14913,
		[
			14913
		]
	],
	"./system-management/bn.resource.json": [
		86624,
		[
			86624
		]
	],
	"./system-management/en.resource.json": [
		56961,
		[
			56961
		]
	],
	"./system-management/es.resource.json": [
		37832,
		[
			37832
		]
	],
	"./system-management/fr.resource.json": [
		78736,
		[
			78736
		]
	],
	"./system-management/gu.resource.json": [
		24116,
		[
			24116
		]
	],
	"./system-management/hi.resource.json": [
		73709,
		[
			73709
		]
	],
	"./system-management/km.resource.json": [
		87000,
		[
			87000
		]
	],
	"./system-management/kn.resource.json": [
		34295,
		[
			34295
		]
	],
	"./system-management/ml.resource.json": [
		72187,
		[
			72187
		]
	],
	"./system-management/mr.resource.json": [
		94061,
		[
			94061
		]
	],
	"./system-management/nl.resource.json": [
		43974,
		[
			43974
		]
	],
	"./system-management/pa.resource.json": [
		65133,
		[
			65133
		]
	],
	"./system-management/ta.resource.json": [
		94721,
		[
			94721
		]
	],
	"./system-management/te.resource.json": [
		80765,
		[
			80765
		]
	],
	"./system-management/vi.resource.json": [
		86615,
		[
			86615
		]
	],
	"./ta-console.resource.json": [
		48621,
		[
			48621
		]
	],
	"./ta.resource.json": [
		4745,
		[
			4745
		]
	],
	"./te-console.resource.json": [
		35417,
		[
			35417
		]
	],
	"./te.resource.json": [
		96709,
		[
			96709
		]
	],
	"./telemedicine/ar.resource.json": [
		96502,
		[
			96502
		]
	],
	"./telemedicine/bn.resource.json": [
		96395,
		[
			96395
		]
	],
	"./telemedicine/en.resource.json": [
		17854,
		[
			17854
		]
	],
	"./telemedicine/es.resource.json": [
		29807,
		[
			29807
		]
	],
	"./telemedicine/fr.resource.json": [
		72539,
		[
			72539
		]
	],
	"./telemedicine/gu.resource.json": [
		93607,
		[
			93607
		]
	],
	"./telemedicine/hi.resource.json": [
		32058,
		[
			32058
		]
	],
	"./telemedicine/km.resource.json": [
		38243,
		[
			38243
		]
	],
	"./telemedicine/kn.resource.json": [
		6388,
		[
			6388
		]
	],
	"./telemedicine/ml.resource.json": [
		98244,
		[
			98244
		]
	],
	"./telemedicine/mr.resource.json": [
		17850,
		[
			17850
		]
	],
	"./telemedicine/nl.resource.json": [
		87189,
		[
			87189
		]
	],
	"./telemedicine/pa.resource.json": [
		33706,
		[
			33706
		]
	],
	"./telemedicine/ta.resource.json": [
		98518,
		[
			98518
		]
	],
	"./telemedicine/te.resource.json": [
		1074,
		[
			1074
		]
	],
	"./telemedicine/vi.resource.json": [
		92484,
		[
			92484
		]
	],
	"./tools/en.resource.json": [
		96333,
		[
			96333
		]
	],
	"./vi.resource.json": [
		67023,
		[
			67023
		]
	],
	"./wallet/ar.resource.json": [
		35535,
		[
			35535
		]
	],
	"./wallet/en.resource.json": [
		71647,
		[
			71647
		]
	],
	"./wallet/es.resource.json": [
		53806,
		[
			53806
		]
	],
	"./wallet/fr.resource.json": [
		87010,
		[
			87010
		]
	],
	"./wallet/gu.resource.json": [
		35346,
		[
			35346
		]
	],
	"./wallet/hi.resource.json": [
		607,
		[
			607
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 62169;
module.exports = webpackAsyncContext;